import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    activeBadgeLabel: {
      ongoing: 'Ongoing',
      todo: 'To do',
    },
    applicationAccountOpening: {
      body: "We will check your company's documents within 24 business hours.",
      title: 'Account opening',
    },
    applicationFunds: {
      bankingInfo: {
        bankAddress: 'Bank address',
        bankName: 'Bank name',
        bic: 'BIC',
        iban: 'IBAN',
        recipientName: 'Recipient name',
        transferLabel: 'Transfer label (mandatory)',
      },
      body: 'Each shareholder must transfer the amount of their capital contribution as indicated on your draft statutes.',
      copied: 'Copied!',
      copy: 'Copy',
      copyAll: 'Copy everything',
      displayBankingInfo: 'Display banking information',
      modalTitle: 'Banking information',
      title: 'Transfer of your capital contribution',
      you: '(You)',
    },
    applicationSentToState: {
      sentToState:
        'Your application has been sent to the administration, we are waiting for its return and validation.',
      title: 'Registration of your company',
    },
    applicationSignature: {
      signStatutes:
        'Sign your **statutes** (initialed, dated and signed) that you will receive from us by email so that we can send your application to the administration for registration.',
      title: 'Registration of your company',
    },
    applicationVerification: {
      body: 'We will check your draft statutes and identity documents within 48 business hours.',
      title: 'Verification of your application',
    },
  },
  fr: {
    activeBadgeLabel: {
      ongoing: 'En cours',
      todo: 'À faire',
    },
    applicationAccountOpening: {
      body: 'Nous vérifions les documents liés à votre entreprise sous 24h ouvrées.',
      title: 'Ouverture du compte',
    },
    applicationFunds: {
      bankingInfo: {
        bankAddress: 'Adresse de la banque',
        bankName: 'Nom de la banque',
        bic: 'BIC',
        iban: 'IBAN',
        recipientName: 'Nom du destinataire',
        transferLabel: 'Intitulé du virement (obligatoire)',
      },
      body: 'Chaque actionnaire doit effectuer le virement correspondant à son apport en capital tel qu’indiqué sur votre projet de statuts.',
      copied: 'Copié !',
      copy: 'Copier',
      copyAll: "Copier l'ensemble",
      displayBankingInfo: 'Afficher les coordonnées bancaires',
      modalTitle: 'Coordonnées bancaires',
      title: 'Virement de vos apports',
      you: '(Vous)',
    },
    applicationSentToState: {
      sentToState:
        'Votre dossier a été envoyé à l’administration, nous attendons son retour et sa validation.',
      title: 'Immatriculation de votre entreprise',
    },
    applicationSignature: {
      signStatutes:
        'Signer vos **statuts** (paraphés, datés et signés) que vous allez recevoir de notre part par email pour que nous puissions envoyer votre dossier à l’administration pour immatriculation.',
      title: 'Immatriculation de votre entreprise',
    },
    applicationVerification: {
      body: 'Nous vérifions votre projet de statuts et vos documents d’identité sous 48h ouvrées.',
      title: 'Vérification de votre dossier',
    },
  },
} as const);
